import { render, staticRenderFns } from "./email-preferences-container.vue?vue&type=template&id=4d020c72"
import script from "./email-preferences-container.vue?vue&type=script&lang=js"
export * from "./email-preferences-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports